import { SxProps, Theme } from "@mui/material";
import { colors } from "../../../../styles/colors";

/**
 * POURQUOI LE NOM DU DOCUMENT ETAIT ILLISIBLE
 * -------------------------------------------
 * `documentCard` portait deux couleurs ecrites en dur :
 *
 *   border: '1px solid #1E293B'
 *   '&:hover': { backgroundColor: '#243044' }
 *
 * Ce sont des valeurs du theme SOMBRE, posees sur un Dialog MUI qui rend sur
 * une surface claire. Au survol, la carte passait donc en bleu nuit pendant
 * que le texte gardait la couleur de texte du theme clair - du gris fonce sur
 * du bleu nuit. D'ou un nom de fichier qui "n'apparait pas" : il etait bien
 * la, a un ratio de contraste d'environ 1.5:1.
 *
 * Le reste de l'application passe par les tokens CSS de styles/colors.ts, qui
 * basculent avec le theme. Ces deux valeurs etaient les seules a y echapper,
 * ce qui explique que le probleme ne se voie que dans cette modale.
 */
export const styles = {
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  } as SxProps<Theme>,

  emptyStateContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 1.5,
    py: 5,
    color: colors.textSecondary,
  } as SxProps<Theme>,

  documentCard: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 2,
    p: 2,
    mb: 1,
    borderRadius: 2,
    border: `1px solid ${colors.borderLight}`,
    backgroundColor: colors.surface,
    // La couleur du texte est posee explicitement plutot que laissee a
    // l'heritage : c'est ce qui garantit qu'elle bouge EN MEME TEMPS que le
    // fond au survol, au lieu de rester calee sur le theme du Dialog.
    color: colors.textPrimary,
    transition: "background-color 0.15s ease, border-color 0.15s ease",
    "&:hover": {
      backgroundColor: colors.bgcolor,
      borderColor: colors.primary,
    },
  } as SxProps<Theme>,

  documentInfo: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    // minWidth 0 : sans cela un nom de fichier long pousse les boutons hors
    // de la carte au lieu de s'ellipser.
    minWidth: 0,
  } as SxProps<Theme>,

  documentName: {
    color: colors.textPrimary,
    fontWeight: 600,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  } as SxProps<Theme>,

  actionButtons: {
    display: "flex",
    gap: 1,
    flexShrink: 0,
  } as SxProps<Theme>,
};
